"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var babel_preset_exports = {};
__export(babel_preset_exports, {
  buildOneBabelPlugins: () => buildOneBabelPlugins,
  buildRouterRequireContextRegexString: () => buildRouterRequireContextRegexString,
  default: () => oneBabelPreset
});
module.exports = __toCommonJS(babel_preset_exports);
var import_path = __toESM(require("path"), 1);
var import_module = require("module");
var import_micromatch = __toESM(require("micromatch"), 1);
var import_tsconfig_paths = __toESM(require("tsconfig-paths"), 1);
var import_env = require("../native/env");
var import_glob_patterns = require("../router/glob-patterns");
function toPosixRelativePath(relativePath) {
  return import_path.default.sep === "\\" ? relativePath.replace(/\\/g, "/") : relativePath;
}
function oneBabelPreset(api) {
  var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  var _options_projectRoot, _options_routerRoot;
  var hasViteInjectedOnePlugins = typeof (api === null || api === void 0 ? void 0 : api.caller) === "function" ? api.caller(function(caller) {
    return !!(caller === null || caller === void 0 ? void 0 : caller.oneViteMetroBabelConfig);
  }) : false;
  var isVxrnCompiler = typeof (api === null || api === void 0 ? void 0 : api.caller) === "function" ? api.caller(function(caller) {
    return (caller === null || caller === void 0 ? void 0 : caller.name) === "vxrn";
  }) : false;
  if (isVxrnCompiler) {
    return {
      presets: [],
      plugins: []
    };
  }
  if (!(api === null || api === void 0 ? void 0 : api.caller) && typeof (api === null || api === void 0 ? void 0 : api.cache) === "function") {
    api.cache(true);
  }
  var projectRoot = import_path.default.resolve((_options_projectRoot = options.projectRoot) !== null && _options_projectRoot !== void 0 ? _options_projectRoot : typeof (api === null || api === void 0 ? void 0 : api.cwd) === "function" ? api.cwd() : process.cwd());
  var require2 = (0, import_module.createRequire)(projectRoot + "/");
  var reactNativePresetPath;
  try {
    reactNativePresetPath = require2.resolve("@react-native/babel-preset");
  } catch (unused) {
    throw new Error(`[one/babel-preset] Could not resolve '@react-native/babel-preset' from ${projectRoot}. Install it as a project dependency (it ships with every React Native app template).`);
  }
  return {
    // presets run right to left: strip TypeScript exports before expanding
    // runtime namespace exports, then let the RN module transform consume them.
    presets: [
      {
        plugins: [
          (0, import_module.createRequire)(require2.resolve("one/package.json")).resolve("@babel/plugin-transform-export-namespace-from")
        ]
      },
      require2(reactNativePresetPath)
    ],
    plugins: hasViteInjectedOnePlugins ? [] : buildOneBabelPlugins({
      projectRoot,
      relativeRouterRoot: (_options_routerRoot = options.routerRoot) !== null && _options_routerRoot !== void 0 ? _options_routerRoot : "app",
      ignoredRouteFiles: options.ignoredRouteFiles,
      linking: options.linking,
      setupFile: options.setupFile,
      includeImportMetaEnv: options.includeImportMetaEnv
    })
  };
}
function buildOneBabelPlugins(param) {
  var { projectRoot, relativeRouterRoot, ignoredRouteFiles, linking, setupFile, includeImportMetaEnv = true } = param;
  var tsconfig = import_tsconfig_paths.default.loadConfig(projectRoot);
  if (tsconfig.resultType === "failed") {
    throw new Error("[one/babel-preset] tsconfig.json paths could not be loaded");
  }
  var require2 = (0, import_module.createRequire)(projectRoot + "/");
  var metroEntryPath = require2.resolve("one/metro-entry", {
    paths: [
      projectRoot
    ]
  });
  var setupFileRelativeToMetroEntry = (function() {
    if (!setupFile) return void 0;
    var file = typeof setupFile === "string" ? setupFile : setupFile.native || setupFile.ios || setupFile.android;
    if (!file) return void 0;
    return toPosixRelativePath(import_path.default.relative(import_path.default.dirname(metroEntryPath), import_path.default.join(projectRoot, file)));
  })();
  return [
    // standalone Metro CLI needs `import.meta.env.*` /
    // `process.env.*` baked in. The Vite path passes `false` here and injects
    // its own version with the user's `define` env via the server hook.
    ...includeImportMetaEnv ? [
      [
        "@vxrn/vite-plugin-metro/babel-plugins/import-meta-env-plugin",
        {
          env: buildStandaloneImportMetaEnv()
        }
      ]
    ] : [],
    "one/babel-plugin-environment-guard",
    [
      "one/babel-plugin-remove-server-code",
      {
        routerRoot: relativeRouterRoot
      }
    ],
    [
      "babel-plugin-module-resolver",
      // "vite-tsconfig-paths" for Metro
      {
        alias: Object.fromEntries(Object.entries(tsconfig.paths).map(function(param2) {
          var [k, v] = param2;
          var key = k.endsWith("/*") ? k.replace(/\/\*$/, "") : `${k}$`;
          var value = v[0].replace(/\/\*$/, "");
          if (!value.startsWith("./")) value = `./${value}`;
          return [
            key,
            value
          ];
        }))
      }
    ],
    [
      "one/babel-plugin-one-router-metro",
      {
        // posix-only, becomes the first arg of `require.context()` in `one-router-metro`;
        // backslashes on Windows drift the babel-emitted AST per platform.
        ONE_ROUTER_APP_ROOT_RELATIVE_TO_ENTRY: toPosixRelativePath(import_path.default.relative(import_path.default.dirname(metroEntryPath), import_path.default.join(projectRoot, relativeRouterRoot))),
        ONE_ROUTER_ROOT_FOLDER_NAME: relativeRouterRoot,
        ONE_ROUTER_REQUIRE_CONTEXT_REGEX_STRING: buildRouterRequireContextRegexString(ignoredRouteFiles),
        ONE_ROUTER_LINKING_CONFIG: linking,
        ONE_SETUP_FILE_NATIVE: setupFileRelativeToMetroEntry
      }
    ],
    "one/babel-plugin-inline-one-server-url"
  ];
}
function buildStandaloneImportMetaEnv() {
  var _process_env_ONE_PLATFORM;
  var isProduction = process.env.NODE_ENV !== "development";
  var expoPlatform = process.env.ONE_PLATFORM === "ios" || process.env.ONE_PLATFORM === "android" ? process.env.ONE_PLATFORM : process.env.EXPO_OS === "ios" || process.env.EXPO_OS === "android" ? process.env.EXPO_OS : void 0;
  var env = {
    ...(0, import_env.pickOnePublicEnv)(process.env),
    MODE: isProduction ? "production" : "development",
    BASE_URL: "/",
    PROD: isProduction,
    DEV: !isProduction,
    SSR: false,
    ONE_PLATFORM: (_process_env_ONE_PLATFORM = process.env.ONE_PLATFORM) !== null && _process_env_ONE_PLATFORM !== void 0 ? _process_env_ONE_PLATFORM : "web",
    ...expoPlatform ? {
      EXPO_OS: expoPlatform
    } : {}
  };
  var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = void 0;
  try {
    for (var _iterator = Object.entries(process.env)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var [key, value] = _step.value;
      if (key.startsWith("ONE_") || key.startsWith("VITE_")) {
        env[key] = value;
      }
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return != null) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }
  return env;
}
function normalizeReSource(source) {
  return source.replace(/\[\\\\\/\]/g, "\\/").replace(/\[\^\\\\\/\]/g, "[^/]");
}
function buildRouterRequireContextRegexString(ignoredRouteFiles) {
  var excludeRes = [
    ...(ignoredRouteFiles || []).map(function(pattern) {
      return import_micromatch.default.makeRe(pattern);
    }),
    ...import_glob_patterns.ROUTE_NATIVE_EXCLUSION_GLOB_PATTERNS.map(function(pattern) {
      return import_micromatch.default.makeRe(pattern);
    }),
    import_micromatch.default.makeRe(import_glob_patterns.API_ROUTE_GLOB_PATTERN)
  ];
  var mustStartWith = String.raw`^(?:(?:^|\/|(?:(?:(?!(?:^|\/)\.).)*?)\/)(?!\.)(?=.)[^/]*?`;
  var mustEndWith = String.raw`)$`;
  var negatives = excludeRes.map(function(re, i) {
    var reSource = normalizeReSource(re.source);
    if (!(reSource.startsWith(mustStartWith) && reSource.endsWith(mustEndWith))) {
      var pattern = ignoredRouteFiles === null || ignoredRouteFiles === void 0 ? void 0 : ignoredRouteFiles[i];
      throw new Error(pattern ? `[one/metro] ignoredRouteFile pattern "${pattern}" is not supported. We cannot process the corresponding regex "${reSource}" for now.` : `Unsupported regex "${reSource}" in "ignoredRouteFiles".`);
    }
    var inner = reSource.slice(mustStartWith.length, reSource.length - mustEndWith.length);
    return String.raw`(?:.*${inner})`;
  });
  return String.raw`^(?:\.\/)(?!${negatives.join("|")}$).*\.tsx?$`;
}
//# sourceMappingURL=index.js.map
